export default __webpack_public_path__ + "static/media/unsplash_richyGreat_gitHub.4e2516c5.jpg";